export default __webpack_public_path__ + "static/collaborate-ionic-317499a9db82adc4c1adc48e4bcf1169.webp";